import api from 'app/shared/utils/api';
import promise from 'promise';

const ListingTeardownActions = {
    requestTeardown(encodedAlias, brand) {
        return dispatch => dispatch(api.listingTeardown.requestTeardown(encodedAlias, brand))
            .then((response) => {
                if (response.success) {
                    return response;
                }
                return promise.reject(response.error);
            })
            .catch((errorRMWModel) => {
                // dispatch
                global.TEMPORARY_global_logger.error(errorRMWModel);
                return promise.reject(errorRMWModel);
            });
    },
    confirmTeardown(verificationToken, brand) {
        return dispatch => dispatch(api.listingTeardown.confirmTeardown(verificationToken, brand))
            .then((response) => {
                if (response.success) {
                    return response;
                }
                return promise.reject(response.error);
            })
            .catch((errorRMWModel) => {
                // dispatch
                global.TEMPORARY_global_logger.error(errorRMWModel);
                return promise.reject(errorRMWModel);
            });
    },
};

export default ListingTeardownActions;
